import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Footer(){
  const { t } = useTranslation()
  return (
    <footer className="mt-12 border-t border-blue-100 bg-white">
      <div className="container mx-auto px-4 py-8 grid sm:grid-cols-2 md:grid-cols-4 gap-6">
        {/* … oder colonns … */}

        <div>
          <h4 className="font-bold mb-2">{t('legal.title')}</h4>
          <ul className="space-y-2">
            <li><Link to="/agb" className="hover:underline">{t('legal.agb')}</Link></li>
            <li><Link to="/datenschutz" className="hover:underline">{t('legal.privacy')}</Link></li>
            <li><Link to="/impressum" className="hover:underline">{t('legal.imprint')}</Link></li>
          </ul>
        </div>
      </div>
      <div className="text-center text-sm text-muted py-4">
        © {new Date().getFullYear()} Locapiol
      </div>
    </footer>
  )
}
